import { useCallback, useEffect, useRef } from 'react'

import type { EventName, EventPayloadMap } from './events'
import { track } from './mixpanel'

export function useTrack() {
  return useCallback(<K extends EventName>(event: K, payload: EventPayloadMap[K]) => {
    track(event, payload)
  }, [])
}

export function useTrackOnMount<K extends EventName>(event: K, payload: EventPayloadMap[K]) {
  const firedRef = useRef(false)

  useEffect(() => {
    if (firedRef.current) return
    firedRef.current = true
    track(event, payload)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
